import React, { useState, useEffect } from "react";
import { IconButton, Badge, Popover, Box, Typography, List, ListItem, ListItemText, Divider, Chip } from "@mui/material";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { fetchData } from "../BaseUrl";

export default function NotificationBell() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const load = async () => {
    try {
      const res = await fetchData("admin/notifications?limit=10");
      const items = res?.data || [];
      setNotifications(items);
      setUnreadCount(items.filter(n => !n.isRead).length);
    } catch {
      // API not ready yet — show empty state
      setNotifications([]);
      setUnreadCount(0);
    }
  };

  useEffect(() => {
    load();
    const interval = setInterval(load, 60000); // poll every 60 seconds
    return () => clearInterval(interval);
  }, []);

  const handleOpen = (e) => { setAnchorEl(e.currentTarget); load(); };
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <Badge badgeContent={unreadCount || 0} color="error" max={99}>
          <NotificationsNoneRoundedIcon />
        </Badge>
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { width: 340, borderRadius: 2, mt: 1 } }}
      >
        <Box sx={{ p: 2, borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography fontWeight={700} fontSize={14}>Notifications</Typography>
          {unreadCount > 0 && <Chip label={`${unreadCount} new`} size="small" color="error" />}
        </Box>
        {notifications.length === 0 ? (
          <Box sx={{ p: 3, textAlign: "center" }}>
            <Typography color="text.secondary" fontSize={13}>No notifications yet</Typography>
          </Box>
        ) : (
          <List dense sx={{ maxHeight: 320, overflowY: "auto" }}>
            {notifications.map((n, i) => (
              <React.Fragment key={n.id || i}>
                <ListItem sx={{ alignItems: "flex-start", opacity: n.isRead ? 0.7 : 1, backgroundColor: n.isRead ? "transparent" : "#f8f6ff" }}>
                  <ListItemText
                    primary={<Typography fontSize={13} fontWeight={n.isRead ? 400 : 600}>{n.title || n.message}</Typography>}
                    secondary={<Typography fontSize={11} color="text.secondary">{n.body || n.description || ""}</Typography>}
                  />
                </ListItem>
                {i < notifications.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        )}
      </Popover>
    </>
  );
}
